import { init as initApm } from '@elastic/apm-rum'

export const apm = initApm({
  serviceName: process.env.REACT_APP_ELK_APM_SERVICE_NAME,
  serverUrl: 'https://elk-apm.telavita.com.br/',
  serviceVersion: '',
  environment: process.env.REACT_APP_ELK_APM_ENVIRONMENT,
  active: process.env.REACT_APP_ELK_APM_ENABLED === 'true'
})